import { useRequestPackageProposalExcelMutation, useRequestPackageProposalPptxMutation } from '@anytag/graphql';

export const usePackageDownloads = () => {
  const { callRequestPackageProposalExcel } = useRequestPackageProposalExcelMutation({ fetchPolicy: 'no-cache' });
  const { callRequestPackageProposalPptx } = useRequestPackageProposalPptxMutation({ fetchPolicy: 'no-cache' });

  return {
    callRequestPackageProposalExcel,
    callRequestPackageProposalPptx
  };
};
